import { TRACKING_LOCAL_STORAGE_KEY, SPLITIO_EVENT_NAMES } from '../config';

export const goToPageTracking = (
  eventLocation: 'search' | 'orders' | 'collections' | 'projects' | 'boards',
  linkPath?: string,
) => {
  const trackingEventName = eventLocation
    ? SPLITIO_EVENT_NAMES[eventLocation]
    : null;

  if (trackingEventName) {
    localStorage.setItem(TRACKING_LOCAL_STORAGE_KEY, trackingEventName);
  }

  if (linkPath) {
    window.location.href = linkPath;
  }
};
